import { BaseScreen, BaseGrid, BaseToolbar, ITableColumn, ICrud, BaseModal, FilterOperator } from "react-epharma-components/lib";
import UserContext from "react-epharma-components/lib/components/context/user";
import React, { useState, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileLines } from "@fortawesome/free-solid-svg-icons";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ServicesAssociationsLogActionLabels } from "@enums/ServicesAssociationsLogAction";
import Helpers from "@helpers";
import Search from "./Search";
import CrudForm from "./Crud";

interface IFlexParameterizationContentProps {
  isActive: boolean;
}

export const FlexParameterizationContent: React.FC<IFlexParameterizationContentProps> = ({ isActive }) => {
  const { checkIfHasPermission, permissionIdList } = useContext(UserContext);
  const hasLogPermission = checkIfHasPermission("#CDLOGSVCASSOC", permissionIdList);
  const [showLogModal, setShowLogModal] = useState(false);

  if (!isActive) return null;

  const logColumns: ITableColumn[] = [
    {
      name: "action",
      displayName: "Ação",
      sortable: true,
      onRender: (value: string) => ServicesAssociationsLogActionLabels[value] || value,
    },
    {
      name: "benefitId",
      displayName: "Código do Plano",
      sortable: true,
    },
    {
      name: "benefitName",
      displayName: "Nome do Plano",
      sortable: true,
    },
    {
      name: "authorName",
      displayName: "Nome do Autor",
      sortable: true,
    },
    {
      name: "createdAt",
      displayName: "Data/Hora",
      type: "datetime",
      sortable: true,
      sorter: "desc" as any,
    },
  ];

  const ColumnsTableGrid: ITableColumn[] = [
    {
      identifier: true,
      name: "id",
      displayName: "Id",
      sortable: false,
    },
    {
      name: "aggregatorName",
      displayName: "Agregador",
      sortable: false,
    },
    {
      name: "clientName",
      displayName: "Cliente",
      sortable: false,
    },
    {
      name: "benefitName",
      displayName: "Plano",
      sortable: false,
    },
    {
      name: "minimumValue",
      displayName: "Valor Mínimo",
      mask: Helpers.decimalMask,
      sortable: false,
      onRender: (value) => `R$${Helpers.toDecimal(value)}`,
    },
    {
      name: "rate",
      displayName: "Taxa",
      sortable: false,
      onRender: (value, record) => `${value}%`,
    },
    {
      name: "limitDays",
      displayName: "Dias limite para reembolso",
      sortable: false,
    },
  ];

  const crud: ICrud = {
    form: <CrudForm />,
    create: {
      show: true,
      permissionId: "#CDNEWSVCASSOC",
    },
    delete: {
      show: true,
      permissionId: "#CDDELSVCASSOC",
    },
    update: {
      show: true,
      permissionId: "#CDUPDSVCASSOC",
    },
    read: {
      show: true,
    },
  };

  return (
    <div className="mt-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="text-muted">Gestão de planos habilitados para o serviço epFlex.</span>
        {hasLogPermission && (
          <OverlayTrigger placement="top" overlay={<Tooltip id="log-tooltip-epflex">Logs de Auditoria</Tooltip>}>
            <Button variant="info" size="sm" onClick={() => setShowLogModal(true)}>
              <FontAwesomeIcon icon={faFileLines} className="mr-1" /> Logs
            </Button>
          </OverlayTrigger>
        )}
      </div>

      <BaseGrid
        name="parameter"
        baseEndpoint={Helpers.endpoints.flexParameterization}
        toolbar={
          <BaseToolbar
            crud={crud}
            search={{
              show: true,
              form: <Search />,
            }}
          />
        }
        columns={ColumnsTableGrid}
      />

      <BaseModal
        name="LogModalServicesAssociations-EpFlex"
        size="xl"
        show={showLogModal}
        title="Logs de Auditoria — epFlex"
        content={
          showLogModal ? (
            <BaseGrid
              name="grid-services-associations-log-EpFlex"
              baseEndpoint={`${Helpers.endpoints.servicesAssociationsLog}`}
              filter={[{ property: "ServiceType", operator: FilterOperator.Equals, value: "EpFlex" }]}
              columns={logColumns}
            />
          ) : undefined
        }
        callbackAfterClose={() => setShowLogModal(false)}
      />
    </div>
  );
};

const FlexScreen: React.FC = () => (
  <BaseScreen title="epharma flex" description="Configuração do epharma flex">
    <FlexParameterizationContent isActive={true} />
  </BaseScreen>
);

export default FlexScreen;
